<template>
    <rkm-area title="CID Principal">
        <Form :data="data" />
        <List :data="data" />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'
import Form from './Form'

export default {
    components: { Form, List },
    props: {
        data: { type: Object, required: true },
    },
}
</script>